export default __webpack_public_path__ + "5cbbd560bcf30acb95dd3b0b0d61645a.png";